import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useProgress } from '../../contexts/ProgressContext';
import TelegramWidget from '../../components/TelegramWidget';
import { PromptBox } from '../../components/CopyButton';
import '../Dashboard.css';
import '../modules/Module.css';
import './Track.css';

const FusionTrack = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { progress } = useProgress();
  const [expandedSections, setExpandedSections] = useState({
    intro: true,
    pourquoi: false,
    chatgpt: false,
    claude: false,
    complement: false,
    workflow: false,
    templates: false,
    projet1: false,
    projet2: false,
    projet3: false,
    automation: false,
    advanced: false,
    business: false,
    faq: false
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const totalProgress = progress?.totalProgress || 0;

  return (
    <div className="dashboard-layout">
      {/* SIDEBAR PRO */}
      <aside className="dashboard-sidebar">
        <div className="sidebar-logo" onClick={() => navigate('/dashboard')}>
          <span className="logo-text">F12IA</span>
          <span className="logo-tm">™</span>
        </div>

        <div className="sidebar-user">
          <div className="user-avatar">
            {user?.firstName?.charAt(0).toUpperCase() || 'U'}
          </div>
          <div className="user-info">
            <span className="user-name">{user?.firstName || 'Utilisateur'}</span>
            <span className="user-role">Membre PRO</span>
          </div>
        </div>

        <nav className="sidebar-nav-pro">
          <div className="nav-label">MENU</div>
          <div className="nav-item" onClick={() => navigate('/dashboard')}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg></span>
            <span className="nav-text">Tableau de bord</span>
          </div>

          <div className="nav-label">FORMATIONS</div>
          <div className="nav-item" onClick={() => navigate('/formation/chatgpt')}>
            <span className="nav-icon chatgpt-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729z"/></svg></span>
            <span className="nav-text">ChatGPT</span>
          </div>
          <div className="nav-item" onClick={() => navigate('/formation/claude')}>
            <span className="nav-icon claude-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M4.709 15.955l4.72-2.647.08-.23-.08-.128-2.251-3.614-.144-.072-4.794.893-.071.158.503 2.332.014.13 2.023 3.178z"/></svg></span>
            <span className="nav-text">Claude Code</span>
          </div>
          <div className="nav-item fusion-nav active" onClick={() => navigate('/formation/fusion')}>
            <span className="nav-icon fusion-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M13 10V3L4 14h7v7l9-11h-7z"/></svg></span>
            <span className="nav-text">Fusion</span>
            <span className="nav-badge-pro">PRO</span>
          </div>

          <div className="nav-label">COMPTE</div>
          <div className="nav-item" onClick={() => navigate('/profile')}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/></svg></span>
            <span className="nav-text">Mon profil</span>
          </div>
          <div className="nav-item" onClick={() => navigate('/resources')}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg></span>
            <span className="nav-text">Ressources</span>
          </div>
          <div className="nav-item" onClick={() => navigate('/certificate')}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="6"/><path d="M8 14l-2 8 6-3 6 3-2-8"/></svg></span>
            <span className="nav-text">Certificat</span>
          </div>
        </nav>

        <div className="sidebar-progress-pro">
          <div className="progress-header">
            <span className="progress-title">Progression</span>
            <span className="progress-value">{Math.round(totalProgress)}%</span>
          </div>
          <div className="progress-bar-pro">
            <div className="progress-fill-pro" style={{ width: `${totalProgress}%` }} />
          </div>
        </div>

        <div className="sidebar-bottom">
          <div className="nav-item logout-item" onClick={handleLogout}>
            <span className="nav-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg></span>
            <span className="nav-text">Déconnexion</span>
          </div>
        </div>
      </aside>

      {/* MAIN CONTENT */}
      <main className="dashboard-main">
        {/* Header PRO avec logos */}
        <div className="fusion-page-header">
          <div className="fusion-logos-header">
            <svg className="fusion-logo-chatgpt" viewBox="0 0 24 24" fill="none">
              <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.8956zm16.5963 3.8558L13.1038 8.364l2.0201-1.1638a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.4091-.6813zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z" fill="#10a37f"/>
            </svg>
            <span className="fusion-plus">+</span>
            <svg className="fusion-logo-claude" viewBox="0 0 24 24" fill="none">
              <path d="M4.709 15.955l4.72-2.647.08-.23-.08-.128-2.251-3.614-.144-.072-4.794.893-.071.158.503 2.332.014.13 2.023 3.178zm7.19-7.553L14.9 4.5l-.087-.197-2.302-.485-.123.037-2.153 3.69.033.164 1.515 1.02.116-.026zm-5.98 5.408l-.043-.082-1.628-.357-.12.052-.71 2.468.03.103 1.26.327.094-.024 1.31-1.73-.072-.439-.12-.318zm10.864-5.334l.228-.152-.014-.182-1.933-1.269-.173.014-.787 1.19.024.18 1.29 1.232.152-.015.07-.062 1.143-.936zm.566 3.592l-3.054-.952-.193.082-.076.176.803 3.982.112.082 2.993-.567.096-.117-.178-2.462-.136-.15-.367-.074zM8.67 7.142l-.164-.068-1.792.674-.054.148 1.18 1.775.163.052 1.627-.902.048-.162-.629-1.385-.379-.132zm5.7 8.211l-.188-.031-1.487 1.235-.014.185.91 1.17.184.026 1.426-1.225.032-.172-.862-1.188zm-1.42-4.048l-.241-.11-3.116 1.764-.053.238.993 1.607.226.065 3.24-1.628.068-.239-1.118-1.697zm-4.313-.12l-.131-.037-.697.366-.02.125.433.678.127.042.702-.37.024-.127-.438-.678z" fill="#cc785c"/>
            </svg>
          </div>
          <div className="track-badge fusion-badge-header">PARCOURS AVANCÉ PRO</div>
          <h1>FUSION : La Puissance Combinée</h1>
          <p className="track-subtitle">
            Maîtrisez l'art de combiner ChatGPT et Claude Code pour créer des projets extraordinaires
          </p>
          <div className="fusion-stats-header">
            <div className="fusion-stat">
              <span className="stat-value">14</span>
              <span className="stat-label">Sections</span>
            </div>
            <div className="fusion-stat">
              <span className="stat-value">50+</span>
              <span className="stat-label">Prompts</span>
            </div>
            <div className="fusion-stat">
              <span className="stat-value">3</span>
              <span className="stat-label">Projets</span>
            </div>
            <div className="fusion-stat">
              <span className="stat-value">∞</span>
              <span className="stat-label">Possibilités</span>
            </div>
          </div>
        </div>

        <div className="track-content">

          {/* ========== SECTION 01 - INTRODUCTION ========== */}
          <div className="track-section">
            <button className={`section-toggle ${expandedSections.intro ? 'active' : ''}`} onClick={() => toggleSection('intro')}>
              <span className="section-number">01</span>
              <span className="section-title">C'est quoi la Fusion ?</span>
              <span className="section-arrow">{expandedSections.intro ? '−' : '+'}</span>
            </button>

            {expandedSections.intro && (
              <div className="section-content">
                <div className="highlight-box fusion-highlight">
                  <strong>🚀 La Fusion en une phrase :</strong><br /><br />
                  <span style={{ fontSize: '1.2rem' }}>
                    C'est utiliser <strong style={{ color: '#10b981' }}>ChatGPT</strong> pour <em>PENSER</em> et <strong style={{ color: '#cc785c' }}>Claude Code</strong> pour <em>CONSTRUIRE</em>.
                  </span>
                </div>

                <h4>🎯 L'analogie parfaite :</h4>
                <div className="comparison-visual">
                  <div className="team-member chatgpt-team">
                    <div className="team-icon">🧠</div>
                    <div className="team-name">ChatGPT</div>
                    <div className="team-role">L'ARCHITECTE</div>
                    <p>Planifie, conseille, écrit, explique, stratégise</p>
                  </div>
                  <div className="team-vs">+</div>
                  <div className="team-member claude-team">
                    <div className="team-icon">🔨</div>
                    <div className="team-name">Claude Code</div>
                    <div className="team-role">LE CONSTRUCTEUR</div>
                    <p>Code, crée, modifie, déploie, exécute</p>
                  </div>
                  <div className="team-equals">=</div>
                  <div className="team-member fusion-team">
                    <div className="team-icon">⚡</div>
                    <div className="team-name">FUSION</div>
                    <div className="team-role">INVINCIBLE</div>
                    <p>Productivité x10, possibilités infinies</p>
                  </div>
                </div>

                <div className="aha-moment fusion-aha">
                  <div className="aha-icon">💡</div>
                  <div className="aha-content">
                    <strong>Le moment "Eureka" :</strong><br /><br />
                    <strong style={{ color: '#10b981' }}>ChatGPT seul</strong> = Des idées géniales... mais aucun fichier créé<br />
                    <strong style={{ color: '#cc785c' }}>Claude Code seul</strong> = Crée des fichiers... mais a besoin de directions<br /><br />
                    <strong style={{ color: '#8b5cf6', fontSize: '1.1rem' }}>ENSEMBLE = Tu peux TOUT créer, de A à Z, en quelques heures !</strong>
                  </div>
                </div>

                <h4>📍 Exemple concret en 4 étapes :</h4>
                <div className="workflow-example">
                  <div className="workflow-step">
                    <div className="step-num">1</div>
                    <div className="step-content">
                      <div className="step-ai chatgpt-ai">ChatGPT</div>
                      <div className="step-action">"Je veux créer un SaaS de gestion de factures"</div>
                      <div className="step-result">→ Tu obtiens : cahier des charges, fonctionnalités, architecture, design</div>
                    </div>
                  </div>
                  <div className="workflow-arrow">↓</div>
                  <div className="workflow-step">
                    <div className="step-num">2</div>
                    <div className="step-content">
                      <div className="step-ai claude-ai">Claude Code</div>
                      <div className="step-action">"Crée ce projet avec tout ce plan"</div>
                      <div className="step-result">→ Tu obtiens : 50+ fichiers, app fonctionnelle, prête à tester</div>
                    </div>
                  </div>
                  <div className="workflow-arrow">↓</div>
                  <div className="workflow-step">
                    <div className="step-num">3</div>
                    <div className="step-content">
                      <div className="step-ai chatgpt-ai">ChatGPT</div>
                      <div className="step-action">"Écris les textes marketing et les emails"</div>
                      <div className="step-result">→ Tu obtiens : landing page, séquence email, descriptions</div>
                    </div>
                  </div>
                  <div className="workflow-arrow">↓</div>
                  <div className="workflow-step">
                    <div className="step-num">4</div>
                    <div className="step-content">
                      <div className="step-ai claude-ai">Claude Code</div>
                      <div className="step-action">"Intègre les textes et déploie sur Vercel"</div>
                      <div className="step-result">→ Tu obtiens : Site EN LIGNE, accessible au monde entier</div>
                    </div>
                  </div>
                  <div className="workflow-final">
                    <span>🎉</span> TON SAAS EST LANCÉ !<br />
                    <small>Temps total : 2-3 heures | Sans IA : 2-3 mois</small>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ========== SECTION 02 - POURQUOI LES DEUX ========== */}
          <div className="track-section">
            <button className={`section-toggle ${expandedSections.pourquoi ? 'active' : ''}`} onClick={() => toggleSection('pourquoi')}>
              <span className="section-number">02</span>
              <span className="section-title">Pourquoi utiliser les deux ?</span>
              <span className="section-arrow">{expandedSections.pourquoi ? '−' : '+'}</span>
            </button>

            {expandedSections.pourquoi && (
              <div className="section-content">
                <div className="warning-box">
                  <strong>⚠️ L'ERREUR FATALE que font 95% des débutants :</strong>
                  <p>Ils utilisent UN SEUL outil pour TOUT faire. C'est comme vouloir construire une maison avec SEULEMENT un marteau !</p>
                </div>

                <h4>📊 Le tableau de vérité :</h4>
                <div className="truth-table">
                  <div className="truth-row header">
                    <div className="truth-task">TÂCHE À FAIRE</div>
                    <div className="truth-best">MEILLEUR OUTIL</div>
                  </div>
                  <div className="truth-row"><div className="truth-task">💡 Brainstormer une idée</div><div className="truth-best chatgpt-best">ChatGPT</div></div>
                  <div className="truth-row"><div className="truth-task">📋 Planifier un projet</div><div className="truth-best chatgpt-best">ChatGPT</div></div>
                  <div className="truth-row"><div className="truth-task">✍️ Écrire du contenu marketing</div><div className="truth-best chatgpt-best">ChatGPT</div></div>
                  <div className="truth-row"><div className="truth-task">🎓 Apprendre un concept</div><div className="truth-best chatgpt-best">ChatGPT</div></div>
                  <div className="truth-row"><div className="truth-task">📁 Créer des fichiers</div><div className="truth-best claude-best">Claude Code</div></div>
                  <div className="truth-row"><div className="truth-task">💻 Écrire du code</div><div className="truth-best claude-best">Claude Code</div></div>
                  <div className="truth-row"><div className="truth-task">🔧 Débugger une erreur</div><div className="truth-best claude-best">Claude Code</div></div>
                  <div className="truth-row"><div className="truth-task">🚀 Déployer un site</div><div className="truth-best claude-best">Claude Code</div></div>
                  <div className="truth-row"><div className="truth-task">📱 Créer une app complète</div><div className="truth-best fusion-best">FUSION !</div></div>
                  <div className="truth-row"><div className="truth-task">💼 Lancer un business</div><div className="truth-best fusion-best">FUSION !</div></div>
                </div>

                <div className="highlight-box fusion-highlight" style={{ marginTop: '24px' }}>
                  <strong>🔮 LA FORMULE MAGIQUE :</strong><br /><br />
                  <div style={{ fontSize: '1.3rem', textAlign: 'center', fontWeight: 'bold' }}>
                    <span style={{ color: '#10b981' }}>PENSER</span>
                    <span style={{ color: '#6b7280', margin: '0 12px' }}>→</span>
                    <span style={{ color: '#cc785c' }}>CONSTRUIRE</span>
                    <span style={{ color: '#6b7280', margin: '0 12px' }}>→</span>
                    <span style={{ color: '#10b981' }}>AMÉLIORER</span>
                    <span style={{ color: '#6b7280', margin: '0 12px' }}>→</span>
                    <span style={{ color: '#cc785c' }}>DÉPLOYER</span>
                  </div>
                  <div style={{ textAlign: 'center', marginTop: '12px', fontSize: '0.9rem', color: '#9ca3af' }}>
                    ChatGPT → Claude → ChatGPT → Claude
                  </div>
                </div>

                <h4>🎯 Cas pratiques :</h4>
                <div className="concrete-examples">
                  <div className="example-card">
                    <div className="example-header"><span className="example-icon">🛒</span><span>Créer une boutique e-commerce</span></div>
                    <div className="example-workflow">
                      <div className="example-step"><span className="step-badge chatgpt-badge">ChatGPT</span><span>Définir la niche, les produits, le positionnement</span></div>
                      <div className="example-step"><span className="step-badge claude-badge">Claude</span><span>Créer le site avec panier, paiement, gestion stock</span></div>
                      <div className="example-step"><span className="step-badge chatgpt-badge">ChatGPT</span><span>Écrire les descriptions produits qui vendent</span></div>
                      <div className="example-step"><span className="step-badge claude-badge">Claude</span><span>Intégrer + déployer + configurer le domaine</span></div>
                    </div>
                  </div>
                  <div className="example-card">
                    <div className="example-header"><span className="example-icon">📚</span><span>Lancer une formation en ligne</span></div>
                    <div className="example-workflow">
                      <div className="example-step"><span className="step-badge chatgpt-badge">ChatGPT</span><span>Structurer le curriculum, écrire les modules</span></div>
                      <div className="example-step"><span className="step-badge claude-badge">Claude</span><span>Créer la plateforme de cours avec login</span></div>
                      <div className="example-step"><span className="step-badge chatgpt-badge">ChatGPT</span><span>Rédiger les quiz et la page de vente</span></div>
                      <div className="example-step"><span className="step-badge claude-badge">Claude</span><span>Intégrer Stripe pour les paiements</span></div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ========== SECTION 03 - SUPER-POUVOIRS CHATGPT ========== */}
          <div className="track-section">
            <button className={`section-toggle ${expandedSections.chatgpt ? 'active' : ''}`} onClick={() => toggleSection('chatgpt')}>
              <span className="section-number">03</span>
              <span className="section-title">Les super-pouvoirs de ChatGPT</span>
              <span className="section-arrow">{expandedSections.chatgpt ? '−' : '+'}</span>
            </button>

            {expandedSections.chatgpt && (
              <div className="section-content">
                <div className="highlight-box" style={{ background: 'rgba(16, 185, 129, 0.1)', borderColor: 'rgba(16, 185, 129, 0.3)' }}>
                  <strong style={{ color: '#10b981' }}>🧠 ChatGPT = Le cerveau qui pense pour toi</strong><br /><br />
                  Ton conseiller stratégique, ton rédacteur, ton professeur particulier.
                </div>

                <h4>💪 Ses 8 super-pouvoirs :</h4>
                <div className="powers-grid">
                  <div className="power-card chatgpt-power">
                    <div className="power-icon">💡</div>
                    <div className="power-title">Brainstorming</div>
                    <div className="power-desc">100 idées en 30 secondes</div>
                  </div>
                  <div className="power-card chatgpt-power">
                    <div className="power-icon">📋</div>
                    <div className="power-title">Planification</div>
                    <div className="power-desc">Plans détaillés étape par étape</div>
                  </div>
                  <div className="power-card chatgpt-power">
                    <div className="power-icon">✍️</div>
                    <div className="power-title">Rédaction</div>
                    <div className="power-desc">Textes persuasifs et pro</div>
                  </div>
                  <div className="power-card chatgpt-power">
                    <div className="power-icon">🎓</div>
                    <div className="power-title">Explication</div>
                    <div className="power-desc">Vulgarise n'importe quoi</div>
                  </div>
                  <div className="power-card chatgpt-power">
                    <div className="power-icon">🔍</div>
                    <div className="power-title">Analyse</div>
                    <div className="power-desc">Décortique et critique</div>
                  </div>
                  <div className="power-card chatgpt-power">
                    <div className="power-icon">🌐</div>
                    <div className="power-title">Traduction</div>
                    <div className="power-desc">Toutes langues avec contexte</div>
                  </div>
                  <div className="power-card chatgpt-power">
                    <div className="power-icon">🎨</div>
                    <div className="power-title">Créativité</div>
                    <div className="power-desc">Noms, slogans, concepts</div>
                  </div>
                  <div className="power-card chatgpt-power">
                    <div className="power-icon">📊</div>
                    <div className="power-title">Stratégie</div>
                    <div className="power-desc">Business plans, roadmaps</div>
                  </div>
                </div>

                <h4 style={{ marginTop: '32px' }}>🎯 Prompts prêts à l'emploi :</h4>

                <PromptBox title="Brainstormer un projet" prompt={`Je veux créer [TYPE DE PROJET].

Aide-moi à brainstormer :
1. 10 variantes de ce concept
2. Les 5 problèmes que ça résout
3. Ma cible idéale (persona détaillé)
4. 5 noms possibles pour le projet
5. Le pitch en une phrase

Sois créatif et propose des angles originaux.`} />

                <PromptBox title="Créer un cahier des charges complet" prompt={`Je veux créer [DESCRIPTION DU PROJET].

Génère un cahier des charges complet avec :

1. **VISION**
   - Objectif principal
   - Problème résolu
   - Public cible

2. **FONCTIONNALITÉS**
   - MVP (5 features essentielles)
   - V2 (features futures)
   - Nice-to-have

3. **PAGES/ÉCRANS**
   - Liste toutes les pages
   - Décris le contenu de chacune

4. **DESIGN**
   - Style visuel
   - Couleurs suggérées
   - Références d'inspiration

5. **TECHNIQUE**
   - Stack recommandée
   - Structure des fichiers

Sois exhaustif et précis.`} />

                <PromptBox title="Écrire du contenu marketing" prompt={`Tu es un copywriter expert. Écris pour [MON PRODUIT] :

1. **HEADLINE** (5 versions accrocheuses)

2. **SOUS-TITRE** (proposition de valeur claire)

3. **SECTION PROBLÈME**
   - 3 douleurs de ma cible
   - Amplification émotionnelle

4. **SECTION SOLUTION**
   - Comment mon produit résout ça
   - 3 bénéfices clés

5. **PREUVES SOCIALES**
   - 3 témoignages fictifs mais réalistes

6. **CTA**
   - Bouton principal
   - Texte d'urgence

Ton : [professionnel/décontracté/luxe]`} />
              </div>
            )}
          </div>

          {/* ========== SECTION 04 - SUPER-POUVOIRS CLAUDE ========== */}
          <div className="track-section">
            <button className={`section-toggle ${expandedSections.claude ? 'active' : ''}`} onClick={() => toggleSection('claude')}>
              <span className="section-number">04</span>
              <span className="section-title">Les super-pouvoirs de Claude Code</span>
              <span className="section-arrow">{expandedSections.claude ? '−' : '+'}</span>
            </button>

            {expandedSections.claude && (
              <div className="section-content">
                <div className="highlight-box" style={{ background: 'rgba(204, 120, 92, 0.1)', borderColor: 'rgba(204, 120, 92, 0.3)' }}>
                  <strong style={{ color: '#cc785c' }}>🔨 Claude Code = Les mains qui construisent</strong><br /><br />
                  Ton développeur personnel, disponible 24/7, qui ne se fatigue jamais.
                </div>

                <h4>💪 Ses 8 super-pouvoirs :</h4>
                <div className="powers-grid">
                  <div className="power-card claude-power">
                    <div className="power-icon">📁</div>
                    <div className="power-title">Création fichiers</div>
                    <div className="power-desc">Crée de vrais fichiers</div>
                  </div>
                  <div className="power-card claude-power">
                    <div className="power-icon">💻</div>
                    <div className="power-title">Code complet</div>
                    <div className="power-desc">Tout langage/framework</div>
                  </div>
                  <div className="power-card claude-power">
                    <div className="power-icon">🔧</div>
                    <div className="power-title">Debugging</div>
                    <div className="power-desc">Trouve et corrige les bugs</div>
                  </div>
                  <div className="power-card claude-power">
                    <div className="power-icon">⚡</div>
                    <div className="power-title">Exécution</div>
                    <div className="power-desc">Lance les commandes</div>
                  </div>
                  <div className="power-card claude-power">
                    <div className="power-icon">📖</div>
                    <div className="power-title">Lecture projet</div>
                    <div className="power-desc">Lit TOUT ton code</div>
                  </div>
                  <div className="power-card claude-power">
                    <div className="power-icon">🔄</div>
                    <div className="power-title">Refactoring</div>
                    <div className="power-desc">Améliore le code existant</div>
                  </div>
                  <div className="power-card claude-power">
                    <div className="power-icon">🚀</div>
                    <div className="power-title">Déploiement</div>
                    <div className="power-desc">Met en ligne</div>
                  </div>
                  <div className="power-card claude-power">
                    <div className="power-icon">🧪</div>
                    <div className="power-title">Tests</div>
                    <div className="power-desc">Écrit et lance les tests</div>
                  </div>
                </div>

                <h4 style={{ marginTop: '32px' }}>🎯 Prompts prêts à l'emploi :</h4>

                <PromptBox title="Créer un projet complet" prompt={`Crée un projet [React/Vue/Next.js] complet pour [DESCRIPTION].

SPÉCIFICATIONS :
- Nom du projet : [nom]
- Pages : [liste des pages]
- Fonctionnalités : [liste]
- Design : [style + couleurs]

EXÉCUTION :
1. Crée la structure complète du projet
2. Implémente toutes les pages
3. Ajoute toutes les fonctionnalités
4. Crée des données de test réalistes
5. Configure le responsive
6. Lance le projet en local

Ne me demande AUCUNE confirmation. Fais tout automatiquement.`} />

                <PromptBox title="Ajouter une fonctionnalité" prompt={`Ajoute cette fonctionnalité au projet existant :

FONCTIONNALITÉ : [description détaillée]

COMPORTEMENT ATTENDU :
- Quand l'utilisateur [action]
- Alors [résultat]

DESIGN :
- Emplacement : [où dans l'interface]
- Style : [cohérent avec l'existant]

Modifie les fichiers nécessaires et montre-moi le résultat.`} />

                <PromptBox title="Débugger une erreur" prompt={`J'ai cette erreur : [COLLE L'ERREUR]

Le contexte :
- Je faisais : [action]
- Dans le fichier : [fichier]
- Après avoir : [changement récent]

Trouve le problème, explique-moi pourquoi ça arrive, et corrige-le.`} />

                <PromptBox title="Déployer sur Vercel" prompt={`Déploie ce projet sur Vercel.

Si le repo Git n'existe pas :
1. Crée le repo GitHub
2. Push le code

Ensuite :
1. Connecte à Vercel
2. Configure le build
3. Déploie

Donne-moi l'URL finale du site.`} />
              </div>
            )}
          </div>

          {/* ========== SECTION 05 - COMPLÉMENTARITÉ ========== */}
          <div className="track-section">
            <button className={`section-toggle ${expandedSections.complement ? 'active' : ''}`} onClick={() => toggleSection('complement')}>
              <span className="section-number">05</span>
              <span className="section-title">Comment ils se complètent parfaitement</span>
              <span className="section-arrow">{expandedSections.complement ? '−' : '+'}</span>
            </button>

            {expandedSections.complement && (
              <div className="section-content">
                <div className="highlight-box fusion-highlight">
                  <strong>🧩 Le puzzle parfait :</strong><br /><br />
                  Les faiblesses de l'un sont exactement les forces de l'autre !
                </div>

                <div className="complement-visual">
                  <div className="complement-side chatgpt-side">
                    <h4 style={{ color: '#10b981' }}>ChatGPT</h4>
                    <div className="complement-list">
                      <div className="complement-item strength"><span className="icon">✅</span><span>Excellent pour réfléchir</span></div>
                      <div className="complement-item weakness"><span className="icon">❌</span><span>Ne crée pas de fichiers</span></div>
                      <div className="complement-item strength"><span className="icon">✅</span><span>Écrit des textes parfaits</span></div>
                      <div className="complement-item weakness"><span className="icon">❌</span><span>Ne voit pas ton projet</span></div>
                      <div className="complement-item strength"><span className="icon">✅</span><span>Interface web simple</span></div>
                      <div className="complement-item weakness"><span className="icon">❌</span><span>N'exécute pas de code</span></div>
                    </div>
                  </div>
                  <div className="complement-center">
                    <div className="complement-arrow">⟷</div>
                    <div className="complement-label">SE COMPLÈTENT</div>
                  </div>
                  <div className="complement-side claude-side">
                    <h4 style={{ color: '#cc785c' }}>Claude Code</h4>
                    <div className="complement-list">
                      <div className="complement-item weakness"><span className="icon">❌</span><span>Moins bon pour brainstormer</span></div>
                      <div className="complement-item strength"><span className="icon">✅</span><span>Crée tous les fichiers</span></div>
                      <div className="complement-item weakness"><span className="icon">❌</span><span>Textes moins créatifs</span></div>
                      <div className="complement-item strength"><span className="icon">✅</span><span>Lit tout ton projet</span></div>
                      <div className="complement-item weakness"><span className="icon">❌</span><span>Nécessite le terminal</span></div>
                      <div className="complement-item strength"><span className="icon">✅</span><span>Exécute tout le code</span></div>
                    </div>
                  </div>
                </div>

                <h4 style={{ marginTop: '32px' }}>🎬 Scénario réel : Créer une landing page</h4>
                <div className="scenario-box">
                  <div className="scenario-title"><span className="scenario-icon">🎯</span>Objectif : Landing page pour vendre un ebook</div>
                  <div className="scenario-steps">
                    <div className="scenario-step">
                      <div className="step-header"><span className="step-badge chatgpt-badge">ÉTAPE 1 - ChatGPT</span></div>
                      <div className="step-prompt">"Je vends un ebook sur la productivité. Écris :<br/>- 5 titres accrocheurs<br/>- La structure de la page<br/>- Les arguments de vente<br/>- Le texte du CTA"</div>
                      <div className="step-result">→ Tu as tout le contenu textuel prêt</div>
                    </div>
                    <div className="scenario-step">
                      <div className="step-header"><span className="step-badge claude-badge">ÉTAPE 2 - Claude Code</span></div>
                      <div className="step-prompt">"Crée une landing page avec ce contenu :<br/>[COLLE TOUT]<br/>Design moderne, violet/blanc, formulaire email"</div>
                      <div className="step-result">→ Ta landing page est créée et fonctionnelle</div>
                    </div>
                    <div className="scenario-step">
                      <div className="step-header"><span className="step-badge chatgpt-badge">ÉTAPE 3 - ChatGPT</span></div>
                      <div className="step-prompt">"Écris 3 emails de bienvenue pour les inscrits"</div>
                      <div className="step-result">→ Tu as ta séquence email</div>
                    </div>
                    <div className="scenario-step">
                      <div className="step-header"><span className="step-badge claude-badge">ÉTAPE 4 - Claude Code</span></div>
                      <div className="step-prompt">"Déploie sur Vercel et connecte le domaine"</div>
                      <div className="step-result">→ Ton site est EN LIGNE !</div>
                    </div>
                  </div>
                  <div className="scenario-final"><strong>⏱️ Temps total : 30-45 minutes</strong><br/><small>Sans IA : plusieurs jours de travail</small></div>
                </div>
              </div>
            )}
          </div>

          {/* ========== SECTION 06 - WORKFLOW PRO ========== */}
          <div className="track-section">
            <button className={`section-toggle ${expandedSections.workflow ? 'active' : ''}`} onClick={() => toggleSection('workflow')}>
              <span className="section-number">06</span>
              <span className="section-title">Le workflow professionnel en 5 phases</span>
              <span className="section-arrow">{expandedSections.workflow ? '−' : '+'}</span>
            </button>

            {expandedSections.workflow && (
              <div className="section-content">
                <div className="highlight-box fusion-highlight">
                  <strong>🏆 Le secret des pros :</strong><br /><br />
                  Ils ont un SYSTÈME répétable. Voici le workflow optimal.
                </div>

                <div className="workflow-phases">
                  <div className="phase">
                    <div className="phase-header">
                      <span className="phase-number">PHASE 1</span>
                      <span className="phase-title">IDÉATION</span>
                      <span className="phase-ai chatgpt-ai">ChatGPT</span>
                    </div>
                    <div className="phase-content">
                      <p><strong>Objectif :</strong> Définir clairement le projet</p>
                      <PromptBox title="Prompt Phase 1" prompt={`Je veux créer [DESCRIPTION].

Aide-moi à définir :
1. Le problème exact que ça résout
2. Ma cible idéale (persona)
3. Les 5 fonctionnalités MVP
4. La stack technique recommandée
5. Un nom pour le projet`} />
                    </div>
                  </div>
                  <div className="phase-arrow">↓</div>
                  <div className="phase">
                    <div className="phase-header">
                      <span className="phase-number">PHASE 2</span>
                      <span className="phase-title">PLANIFICATION</span>
                      <span className="phase-ai chatgpt-ai">ChatGPT</span>
                    </div>
                    <div className="phase-content">
                      <p><strong>Objectif :</strong> Créer le cahier des charges complet</p>
                      <PromptBox title="Prompt Phase 2" prompt={`Parfait. Maintenant crée le cahier des charges complet :

1. TOUTES les pages du site/app
2. Le contenu de chaque page
3. Les fonctionnalités détaillées
4. Le parcours utilisateur
5. Le design (couleurs, style)
6. L'architecture des fichiers`} />
                    </div>
                  </div>
                  <div className="phase-arrow">↓</div>
                  <div className="phase">
                    <div className="phase-header">
                      <span className="phase-number">PHASE 3</span>
                      <span className="phase-title">CONSTRUCTION</span>
                      <span className="phase-ai claude-ai">Claude Code</span>
                    </div>
                    <div className="phase-content">
                      <p><strong>Objectif :</strong> Créer le projet complet</p>
                      <PromptBox title="Prompt Phase 3" prompt={`Crée ce projet en React :

[COLLE LE CAHIER DES CHARGES DE CHATGPT]

Exécution :
1. Crée tous les fichiers
2. Implémente toutes les fonctionnalités
3. Ajoute des données de test
4. Lance le projet

Ne demande aucune confirmation.`} />
                    </div>
                  </div>
                  <div className="phase-arrow">↓</div>
                  <div className="phase">
                    <div className="phase-header">
                      <span className="phase-number">PHASE 4</span>
                      <span className="phase-title">AMÉLIORATION</span>
                      <span className="phase-ai chatgpt-ai">ChatGPT + Claude</span>
                    </div>
                    <div className="phase-content">
                      <p><strong>Objectif :</strong> Perfectionner le projet</p>
                      <p>→ ChatGPT : "Quelles améliorations suggères-tu ?"</p>
                      <p>→ Claude Code : "Implémente ces améliorations : [liste]"</p>
                    </div>
                  </div>
                  <div className="phase-arrow">↓</div>
                  <div className="phase">
                    <div className="phase-header">
                      <span className="phase-number">PHASE 5</span>
                      <span className="phase-title">DÉPLOIEMENT</span>
                      <span className="phase-ai claude-ai">Claude Code</span>
                    </div>
                    <div className="phase-content">
                      <p><strong>Objectif :</strong> Mettre en ligne</p>
                      <PromptBox title="Prompt Phase 5" prompt={`Déploie ce projet :
1. Push sur GitHub
2. Connecte à Vercel
3. Déploie
4. Donne-moi l'URL`} />
                    </div>
                  </div>
                </div>

                <div className="pro-tip" style={{ marginTop: '32px' }}>
                  <div className="pro-tip-header"><span className="pro-tip-icon">💡</span><span>ASTUCE PRO</span></div>
                  <div className="pro-tip-content">
                    <strong>Garde les deux fenêtres ouvertes côte à côte !</strong><br/>
                    • Gauche : ChatGPT dans le navigateur<br/>
                    • Droite : Terminal avec Claude Code<br/>
                    <br/>
                    Copie-colle facilement d'un outil à l'autre.
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ========== SECTION 07 - TEMPLATES ========== */}
          <div className="track-section">
            <button className={`section-toggle ${expandedSections.templates ? 'active' : ''}`} onClick={() => toggleSection('templates')}>
              <span className="section-number">07</span>
              <span className="section-title">📋 Bibliothèque de Templates (20+ prompts)</span>
              <span className="section-arrow">{expandedSections.templates ? '−' : '+'}</span>
            </button>

            {expandedSections.templates && (
              <div className="section-content">
                <div className="highlight-box fusion-highlight">
                  <strong>📚 Ta boîte à outils complète :</strong><br /><br />
                  Copie-colle ces templates et adapte-les à ton projet. Tous testés et optimisés !
                </div>

                <h4>🧠 Templates ChatGPT :</h4>

                <PromptBox title="TEMPLATE : Valider une idée business" prompt={`Je pense créer [IDÉE].

Fais une analyse complète :

1. **MARCHÉ**
   - Taille estimée
   - Tendances actuelles
   - Concurrents existants

2. **FORCES/FAIBLESSES**
   - Avantages de cette idée
   - Risques potentiels
   - Barrières à l'entrée

3. **CIBLE**
   - Qui achèterait ?
   - Pourquoi ?
   - Combien paierait-il ?

4. **VERDICT**
   - Note sur 10
   - Recommandation : Go / Pivot / Abandon
   - Suggestions d'amélioration`} />

                <PromptBox title="TEMPLATE : Écrire une page de vente" prompt={`Écris une page de vente COMPLÈTE pour [PRODUIT].

Structure :
1. **HEADLINE** - Accroche principale (5 versions)
2. **SOUS-TITRE** - Proposition de valeur
3. **SECTION PROBLÈME** - 3 douleurs de la cible
4. **AGITATION** - Amplification émotionnelle
5. **SOLUTION** - Comment le produit résout ça
6. **BÉNÉFICES** - 5 bénéfices clés avec emojis
7. **FONCTIONNALITÉS** - Liste détaillée
8. **PREUVE SOCIALE** - 3 témoignages fictifs réalistes
9. **PRIX** - Présentation du tarif avec ancrage
10. **GARANTIE** - Réduire le risque
11. **CTA** - 3 versions du bouton
12. **FAQ** - 5 questions/réponses

Cible : [DESCRIPTION]
Ton : [professionnel/décontracté/premium]
Prix : [MONTANT]`} />

                <PromptBox title="TEMPLATE : Créer du contenu pour réseaux sociaux" prompt={`Je vends [PRODUIT] à [CIBLE].

Crée un calendrier de contenu pour 1 mois :

**SEMAINE 1 - Sensibilisation**
- 3 posts éducatifs
- 1 story interactive
- 1 carrousel

**SEMAINE 2 - Engagement**
- 2 posts témoignages
- 1 sondage
- 2 posts behind-the-scenes

**SEMAINE 3 - Conversion**
- 2 posts produit
- 1 offre limitée
- 2 posts FAQ

**SEMAINE 4 - Fidélisation**
- 1 post communauté
- 2 posts tips
- 1 post récapitulatif

Pour chaque post, donne :
- Le texte complet
- Les hashtags
- L'idée visuelle`} />

                <h4 style={{ marginTop: '40px' }}>🔨 Templates Claude Code :</h4>

                <PromptBox title="TEMPLATE : Créer un projet React complet" prompt={`Crée un projet React complet : [DESCRIPTION]

STRUCTURE :
/src
  /components (composants réutilisables)
  /pages (pages de l'app)
  /hooks (hooks personnalisés)
  /contexts (state global)
  /utils (fonctions utilitaires)
  /styles (CSS/styled)
  /assets (images, icônes)

PAGES À CRÉER :
1. [Page 1]
2. [Page 2]
3. [Page 3]

FONCTIONNALITÉS :
- [Fonctionnalité 1]
- [Fonctionnalité 2]
- [Fonctionnalité 3]

DESIGN :
- Style : [moderne/minimaliste/coloré]
- Couleurs : [primaire, secondaire, accent]
- Responsive : mobile-first

DONNÉES :
- Crée des données de test réalistes
- Utilise localStorage pour la persistance

Lance le projet quand c'est prêt.`} />

                <PromptBox title="TEMPLATE : Ajouter authentification" prompt={`Ajoute un système d'authentification complet :

FONCTIONNALITÉS :
1. Page de connexion
2. Page d'inscription
3. Réinitialisation mot de passe
4. Protection des routes
5. Context d'authentification
6. Persistance de session (localStorage)

UX :
- Validation des formulaires
- Messages d'erreur clairs
- Loading states
- Redirection après login

SÉCURITÉ :
- Hashage des mots de passe (simulé côté client pour MVP)
- Tokens de session
- Déconnexion automatique

Intègre ça proprement dans le projet existant.`} />

                <PromptBox title="TEMPLATE : Ajouter un panier e-commerce" prompt={`Ajoute un système de panier e-commerce complet :

FONCTIONNALITÉS :
1. Ajouter au panier (avec animation)
2. Voir le panier (sidebar ou page)
3. Modifier les quantités
4. Supprimer des articles
5. Calculer le total
6. Persistance localStorage
7. Badge avec nombre d'articles

UX :
- Feedback visuel à chaque action
- Résumé toujours visible
- Bouton "Vider le panier"

CHECKOUT :
- Formulaire de livraison
- Récapitulatif commande
- Bouton de paiement (mock)

Intègre avec le catalogue produits existant.`} />

                <PromptBox title="TEMPLATE : Mode sombre/clair" prompt={`Ajoute un système de thème sombre/clair :

FONCTIONNALITÉS :
1. Toggle dans le header/navbar
2. Détection de la préférence système
3. Persistance du choix (localStorage)
4. Transition fluide entre les thèmes
5. Variables CSS pour les couleurs

THÈME CLAIR :
- Background : #ffffff
- Texte : #1a1a1a
- Accent : [couleur]

THÈME SOMBRE :
- Background : #0a0a0a
- Texte : #f5f5f5
- Accent : [couleur]

Applique le thème à TOUTES les pages et composants.`} />

              </div>
            )}
          </div>

          {/* ========== SECTION 08 - PROJET 1 ========== */}
          <div className="track-section">
            <button className={`section-toggle ${expandedSections.projet1 ? 'active' : ''}`} onClick={() => toggleSection('projet1')}>
              <span className="section-number">08</span>
              <span className="section-title">🛒 Projet 1 : E-commerce complet</span>
              <span className="section-arrow">{expandedSections.projet1 ? '−' : '+'}</span>
            </button>

            {expandedSections.projet1 && (
              <div className="section-content">
                <div className="project-overview">
                  <h4>🎯 Ce que tu vas créer :</h4>
                  <ul className="project-features">
                    <li>Boutique en ligne professionnelle</li>
                    <li>Catalogue produits avec filtres</li>
                    <li>Pages produits détaillées</li>
                    <li>Panier d'achat fonctionnel</li>
                    <li>Système de favoris</li>
                    <li>Recherche en temps réel</li>
                    <li>Mode sombre/clair</li>
                    <li>Design responsive</li>
                  </ul>
                </div>

                <div className="exercise-steps">
                  <div className="exercise-step">
                    <div className="exercise-step-header">
                      <span className="step-badge chatgpt-badge">ÉTAPE 1</span>
                      <span className="step-title">Planification avec ChatGPT</span>
                    </div>
                    <PromptBox title="Copie ce prompt dans ChatGPT" prompt={`Je veux créer un e-commerce de sneakers premium.

Aide-moi à planifier :
1. Les 8 pages nécessaires avec leur contenu
2. Les fonctionnalités de chaque page
3. Le parcours utilisateur type
4. Le design (couleurs : noir, blanc, orange)
5. Les catégories de produits
6. La structure des données produit`} />
                  </div>

                  <div className="exercise-step">
                    <div className="exercise-step-header">
                      <span className="step-badge claude-badge">ÉTAPE 2</span>
                      <span className="step-title">Création avec Claude Code</span>
                    </div>
                    <PromptBox title="Copie ce prompt dans Claude Code" prompt={`Crée un e-commerce de sneakers en React avec :

PAGES :
- Accueil (hero + produits vedettes + catégories)
- Catalogue (grille + filtres + tri)
- Page produit (galerie + détails + tailles + ajout panier)
- Panier (liste + quantités + total + checkout)
- Favoris (wishlist)
- À propos
- Contact

FONCTIONNALITÉS :
- Panier avec localStorage
- Favoris avec localStorage
- Recherche temps réel
- Filtres par catégorie/prix/taille
- Tri (prix, nouveauté)

DESIGN :
- Noir (#0a0a0a), blanc, orange (#f97316)
- Moderne et premium
- Animations subtiles
- 100% responsive

DONNÉES :
- 12 sneakers avec images placeholder
- Catégories : Running, Lifestyle, Basketball, Skateboard

Crée tout et lance le projet.`} />
                  </div>

                  <div className="exercise-step">
                    <div className="exercise-step-header">
                      <span className="step-badge chatgpt-badge">ÉTAPE 3</span>
                      <span className="step-title">Contenu avec ChatGPT</span>
                    </div>
                    <PromptBox title="Copie ce prompt" prompt={`Pour mon e-commerce de sneakers, écris :

1. 12 noms de sneakers créatifs
2. 12 descriptions produits (150 mots chacune, vendeurs)
3. Le texte de la page d'accueil
4. La section "Pourquoi nous choisir" (4 arguments)
5. 5 avis clients réalistes
6. Les textes du footer`} />
                  </div>

                  <div className="exercise-step">
                    <div className="exercise-step-header">
                      <span className="step-badge claude-badge">ÉTAPE 4</span>
                      <span className="step-title">Intégration avec Claude Code</span>
                    </div>
                    <PromptBox title="Copie ce prompt" prompt={`Mets à jour le site avec ce contenu :

[COLLE TOUT CE QUE CHATGPT T'A DONNÉ]

Remplace tous les textes placeholder par ce vrai contenu.`} />
                  </div>

                  <div className="exercise-step">
                    <div className="exercise-step-header">
                      <span className="step-badge claude-badge">ÉTAPE 5</span>
                      <span className="step-title">Mode sombre + Améliorations</span>
                    </div>
                    <PromptBox title="Copie ce prompt" prompt={`Ajoute ces améliorations :

1. Mode sombre/clair avec toggle
2. Animations au survol des produits
3. Toast notifications (ajout panier, favoris)
4. Loading skeleton pendant le chargement
5. Badge "Nouveau" sur les 3 derniers produits`} />
                  </div>

                  <div className="exercise-step final">
                    <div className="exercise-step-header">
                      <span className="step-badge claude-badge">ÉTAPE 6</span>
                      <span className="step-title">Déploiement</span>
                    </div>
                    <PromptBox title="Copie ce prompt" prompt={`Déploie ce projet :
1. Push sur GitHub (crée le repo si nécessaire)
2. Connecte à Vercel
3. Déploie
4. Donne-moi l'URL du site en ligne`} />
                  </div>
                </div>

                <div className="project-result">
                  <div className="result-header"><span className="result-icon">🎉</span><span>RÉSULTAT</span></div>
                  <div className="result-content">
                    Tu as maintenant un e-commerce professionnel :<br/><br/>
                    ✓ Design premium noir/orange<br/>
                    ✓ Panier fonctionnel<br/>
                    ✓ Système de favoris<br/>
                    ✓ Recherche et filtres<br/>
                    ✓ Mode sombre/clair<br/>
                    ✓ 100% responsive<br/>
                    ✓ Déployé en ligne<br/><br/>
                    <strong>⏱️ Temps : ~2 heures | 💰 Valeur : 2000-5000€</strong>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ========== SECTION 09 - PROJET 2 ========== */}
          <div className="track-section">
            <button className={`section-toggle ${expandedSections.projet2 ? 'active' : ''}`} onClick={() => toggleSection('projet2')}>
              <span className="section-number">09</span>
              <span className="section-title">📊 Projet 2 : Dashboard SaaS</span>
              <span className="section-arrow">{expandedSections.projet2 ? '−' : '+'}</span>
            </button>

            {expandedSections.projet2 && (
              <div className="section-content">
                <div className="project-overview">
                  <h4>🎯 Ce que tu vas créer :</h4>
                  <ul className="project-features">
                    <li>Dashboard analytics moderne</li>
                    <li>Graphiques interactifs</li>
                    <li>Tableaux de données</li>
                    <li>Système d'authentification</li>
                    <li>Paramètres utilisateur</li>
                    <li>Sidebar navigation</li>
                    <li>Notifications</li>
                    <li>Export de données</li>
                  </ul>
                </div>

                <div className="exercise-steps">
                  <div className="exercise-step">
                    <div className="exercise-step-header">
                      <span className="step-badge chatgpt-badge">ÉTAPE 1</span>
                      <span className="step-title">Concept avec ChatGPT</span>
                    </div>
                    <PromptBox title="Prompt ChatGPT" prompt={`Je veux créer un dashboard SaaS pour [NICHE].

Aide-moi à définir :
1. Les métriques clés à afficher
2. Les différentes sections du dashboard
3. Les types de graphiques adaptés
4. Le parcours utilisateur
5. Les fonctionnalités premium vs gratuit`} />
                  </div>

                  <div className="exercise-step">
                    <div className="exercise-step-header">
                      <span className="step-badge claude-badge">ÉTAPE 2</span>
                      <span className="step-title">Création avec Claude</span>
                    </div>
                    <PromptBox title="Prompt Claude Code" prompt={`Crée un dashboard SaaS en React avec :

LAYOUT :
- Sidebar (navigation + logo + user)
- Header (search + notifications + profil)
- Main content (grille de widgets)

PAGES :
- Dashboard (overview avec stats et graphiques)
- Analytics (graphiques détaillés)
- Utilisateurs (tableau avec CRUD)
- Paramètres (formulaires)
- Profil

COMPOSANTS :
- Cartes de statistiques (avec icônes et tendances)
- Graphiques (lignes, barres, donut) avec Recharts
- Tableau de données avec pagination
- Formulaires avec validation

DESIGN :
- Thème sombre par défaut
- Couleurs : #1a1a2e, #16213e, #0f3460, #e94560
- Coins arrondis, ombres subtiles

DONNÉES :
- Données de démo réalistes
- Simulation de chargement

Crée tout et lance le projet.`} />
                  </div>

                  <div className="exercise-step final">
                    <div className="exercise-step-header">
                      <span className="step-badge claude-badge">ÉTAPE 3</span>
                      <span className="step-title">Authentification + Déploiement</span>
                    </div>
                    <PromptBox title="Prompt final" prompt={`Ajoute :
1. Système d'authentification (login/register)
2. Protection des routes
3. Stockage de la session
4. Page de connexion élégante

Puis déploie sur Vercel.`} />
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ========== SECTION 10 - PROJET 3 ========== */}
          <div className="track-section">
            <button className={`section-toggle ${expandedSections.projet3 ? 'active' : ''}`} onClick={() => toggleSection('projet3')}>
              <span className="section-number">10</span>
              <span className="section-title">📚 Projet 3 : Plateforme de cours</span>
              <span className="section-arrow">{expandedSections.projet3 ? '−' : '+'}</span>
            </button>

            {expandedSections.projet3 && (
              <div className="section-content">
                <div className="project-overview">
                  <h4>🎯 Ce que tu vas créer :</h4>
                  <ul className="project-features">
                    <li>Plateforme de formation en ligne</li>
                    <li>Catalogue de cours</li>
                    <li>Lecteur vidéo</li>
                    <li>Suivi de progression</li>
                    <li>Quiz interactifs</li>
                    <li>Certificats</li>
                    <li>Système de paiement</li>
                    <li>Espace membre</li>
                  </ul>
                </div>

                <div className="exercise-steps">
                  <div className="exercise-step">
                    <div className="exercise-step-header">
                      <span className="step-badge chatgpt-badge">ÉTAPE 1</span>
                      <span className="step-title">Curriculum avec ChatGPT</span>
                    </div>
                    <PromptBox title="Prompt ChatGPT" prompt={`Je veux créer une plateforme de cours sur [SUJET].

Crée :
1. Le curriculum complet (5 modules, 20 leçons)
2. La description de chaque leçon
3. Les objectifs d'apprentissage
4. 5 quiz avec corrections
5. Le texte de la page de vente
6. Les témoignages fictifs`} />
                  </div>

                  <div className="exercise-step">
                    <div className="exercise-step-header">
                      <span className="step-badge claude-badge">ÉTAPE 2</span>
                      <span className="step-title">Plateforme avec Claude</span>
                    </div>
                    <PromptBox title="Prompt Claude Code" prompt={`Crée une plateforme de cours en React :

PAGES PUBLIQUES :
- Landing page (vente du cours)
- Aperçu du curriculum
- FAQ
- Contact

ESPACE MEMBRE :
- Dashboard apprenant
- Liste des modules
- Page leçon (vidéo + texte + ressources)
- Quiz interactif
- Page progression
- Certificat (généré dynamiquement)

FONCTIONNALITÉS :
- Auth (inscription/connexion)
- Suivi progression (localStorage)
- Quiz avec score
- Déblocage progressif des leçons

DESIGN :
- Moderne, épuré
- Couleurs : violet (#8b5cf6), blanc, gris foncé
- Animations subtiles

[COLLE LE CURRICULUM DE CHATGPT]

Crée tout et lance.`} />
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ========== SECTION 11 - AUTOMATISATION ========== */}
          <div className="track-section">
            <button className={`section-toggle ${expandedSections.automation ? 'active' : ''}`} onClick={() => toggleSection('automation')}>
              <span className="section-number">11</span>
              <span className="section-title">⚡ Automatisation avancée</span>
              <span className="section-arrow">{expandedSections.automation ? '−' : '+'}</span>
            </button>

            {expandedSections.automation && (
              <div className="section-content">
                <div className="highlight-box fusion-highlight">
                  <strong>🚀 Le niveau supérieur :</strong><br /><br />
                  Automatise tes workflows pour créer des projets encore plus vite !
                </div>

                <h4>📋 Le Super-Prompt ultime :</h4>
                <PromptBox title="SUPER-PROMPT - Projet complet en 1 message" prompt={`MODE: CRÉATION AUTOMATIQUE COMPLÈTE

PROJET: [Nom du projet]
TYPE: [E-commerce / SaaS / Portfolio / Blog / App]
DESCRIPTION: [Description en 2-3 phrases]

PAGES:
1. [Page 1]
2. [Page 2]
3. [Page 3]
4. [Page 4]

FONCTIONNALITÉS:
- [Fonctionnalité 1]
- [Fonctionnalité 2]
- [Fonctionnalité 3]
- [Fonctionnalité 4]

DESIGN:
- Style: [moderne/minimaliste/coloré/premium]
- Couleurs: [couleur1, couleur2, accent]
- Inspiration: [site de référence si applicable]

EXÉCUTION AUTOMATIQUE:
1. Crée le projet avec la structure complète
2. Implémente TOUTES les pages
3. Ajoute TOUTES les fonctionnalités
4. Crée des données de test réalistes
5. Configure le responsive parfait
6. Ajoute des animations subtiles
7. Optimise les performances
8. Lance le projet en local

⚠️ IMPORTANT:
- Ne me demande AUCUNE confirmation
- Ne t'arrête pas entre les étapes
- Fais TOUT automatiquement
- Montre-moi uniquement le résultat final`} />

                <h4 style={{ marginTop: '32px' }}>📁 Organise tes prompts :</h4>
                <div className="info-box">
                  Crée un dossier <code>mes-prompts/</code> avec :
                  <ul style={{ marginTop: '12px' }}>
                    <li><code>chatgpt-ideation.txt</code> - Prompts de brainstorming</li>
                    <li><code>chatgpt-contenu.txt</code> - Prompts de rédaction</li>
                    <li><code>claude-creation.txt</code> - Prompts de création projet</li>
                    <li><code>claude-features.txt</code> - Prompts d'ajout de fonctionnalités</li>
                    <li><code>super-prompts.txt</code> - Tes meilleurs prompts</li>
                  </ul>
                </div>
              </div>
            )}
          </div>

          {/* ========== SECTION 12 - CAS AVANCÉS ========== */}
          <div className="track-section">
            <button className={`section-toggle ${expandedSections.advanced ? 'active' : ''}`} onClick={() => toggleSection('advanced')}>
              <span className="section-number">12</span>
              <span className="section-title">🎯 Cas d'utilisation avancés</span>
              <span className="section-arrow">{expandedSections.advanced ? '−' : '+'}</span>
            </button>

            {expandedSections.advanced && (
              <div className="section-content">
                <div className="advanced-cases">
                  <div className="case-card">
                    <div className="case-header"><span className="case-icon">💼</span><span className="case-title">Lancer un SaaS</span></div>
                    <div className="case-workflow">
                      <div className="case-step"><span className="step-badge chatgpt-badge">ChatGPT</span><span>Valider l'idée + pitch + positionnement</span></div>
                      <div className="case-step"><span className="step-badge claude-badge">Claude</span><span>Créer la landing de pré-lancement</span></div>
                      <div className="case-step"><span className="step-badge chatgpt-badge">ChatGPT</span><span>Emails de waitlist</span></div>
                      <div className="case-step"><span className="step-badge claude-badge">Claude</span><span>Développer le MVP</span></div>
                      <div className="case-step"><span className="step-badge claude-badge">Claude</span><span>Intégrer Stripe</span></div>
                    </div>
                  </div>
                  <div className="case-card">
                    <div className="case-header"><span className="case-icon">🎨</span><span className="case-title">Agence web (pour clients)</span></div>
                    <div className="case-workflow">
                      <div className="case-step"><span className="step-badge chatgpt-badge">ChatGPT</span><span>Créer le brief client</span></div>
                      <div className="case-step"><span className="step-badge chatgpt-badge">ChatGPT</span><span>Rédiger le contenu</span></div>
                      <div className="case-step"><span className="step-badge claude-badge">Claude</span><span>Créer le site</span></div>
                      <div className="case-step"><span className="step-badge claude-badge">Claude</span><span>Déployer + domaine client</span></div>
                      <div className="case-step"><span className="step-badge chatgpt-badge">ChatGPT</span><span>Doc de formation client</span></div>
                    </div>
                  </div>
                  <div className="case-card">
                    <div className="case-header"><span className="case-icon">📱</span><span className="case-title">App mobile</span></div>
                    <div className="case-workflow">
                      <div className="case-step"><span className="step-badge chatgpt-badge">ChatGPT</span><span>User stories + wireframes</span></div>
                      <div className="case-step"><span className="step-badge claude-badge">Claude</span><span>Créer l'app React Native</span></div>
                      <div className="case-step"><span className="step-badge claude-badge">Claude</span><span>API backend</span></div>
                      <div className="case-step"><span className="step-badge chatgpt-badge">ChatGPT</span><span>Textes store (App Store/Play Store)</span></div>
                    </div>
                  </div>
                  <div className="case-card">
                    <div className="case-header"><span className="case-icon">🛠️</span><span className="case-title">Outil interne entreprise</span></div>
                    <div className="case-workflow">
                      <div className="case-step"><span className="step-badge chatgpt-badge">ChatGPT</span><span>Analyser le besoin + specs</span></div>
                      <div className="case-step"><span className="step-badge claude-badge">Claude</span><span>Créer l'outil sur mesure</span></div>
                      <div className="case-step"><span className="step-badge claude-badge">Claude</span><span>Connecter aux APIs internes</span></div>
                      <div className="case-step"><span className="step-badge chatgpt-badge">ChatGPT</span><span>Documentation utilisateur</span></div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ========== SECTION 13 - BUSINESS ========== */}
          <div className="track-section">
            <button className={`section-toggle ${expandedSections.business ? 'active' : ''}`} onClick={() => toggleSection('business')}>
              <span className="section-number">13</span>
              <span className="section-title">💰 Monétiser avec la Fusion</span>
              <span className="section-arrow">{expandedSections.business ? '−' : '+'}</span>
            </button>

            {expandedSections.business && (
              <div className="section-content">
                <div className="highlight-box" style={{ background: 'rgba(16, 185, 129, 0.1)', borderColor: 'rgba(16, 185, 129, 0.3)' }}>
                  <strong style={{ color: '#10b981' }}>💡 La Fusion = Ton super-pouvoir business</strong><br /><br />
                  Tu peux maintenant créer en quelques heures ce qui prenait des semaines. Voici comment en tirer profit.
                </div>

                <h4>🎯 5 façons de gagner de l'argent :</h4>
                <div className="business-cards">
                  <div className="business-card">
                    <div className="price">500-2000€</div>
                    <h4>Sites vitrines pour PME</h4>
                    <p>Créer des sites pour des commerces locaux, artisans, professions libérales</p>
                  </div>
                  <div className="business-card">
                    <div className="price">1500-5000€</div>
                    <h4>E-commerce pour clients</h4>
                    <p>Boutiques en ligne complètes avec panier et paiement</p>
                  </div>
                  <div className="business-card">
                    <div className="price">2000-10000€</div>
                    <h4>Applications sur mesure</h4>
                    <p>Outils internes, dashboards, automatisations</p>
                  </div>
                  <div className="business-card">
                    <div className="price">Récurrent</div>
                    <h4>Ton propre SaaS</h4>
                    <p>Crée un produit et vends des abonnements</p>
                  </div>
                </div>

                <div className="info-box" style={{ marginTop: '24px' }}>
                  <strong>🚀 Le calcul :</strong><br/><br/>
                  • Tu crées un site en 3 heures<br/>
                  • Tu le vends 1500€<br/>
                  • = <strong>500€/heure</strong><br/><br/>
                  Même un développeur senior ne gagne pas autant !
                </div>
              </div>
            )}
          </div>

          {/* ========== SECTION 14 - FAQ ========== */}
          <div className="track-section">
            <button className={`section-toggle ${expandedSections.faq ? 'active' : ''}`} onClick={() => toggleSection('faq')}>
              <span className="section-number">14</span>
              <span className="section-title">❓ Questions fréquentes</span>
              <span className="section-arrow">{expandedSections.faq ? '−' : '+'}</span>
            </button>

            {expandedSections.faq && (
              <div className="section-content">
                <div className="faq-list">
                  <div className="faq-item">
                    <div className="faq-q">Ça coûte combien au total ?</div>
                    <div className="faq-a">
                      <strong>Environ 25-50$/mois :</strong><br/>
                      • ChatGPT Plus : 20$/mois (optionnel, la version gratuite suffit)<br/>
                      • Claude Code : ~5-10$/projet (facturation à l'usage)<br/>
                      • Vercel : Gratuit pour commencer
                    </div>
                  </div>
                  <div className="faq-item">
                    <div className="faq-q">Dans quel ordre les utiliser ?</div>
                    <div className="faq-a"><strong>Toujours :</strong> ChatGPT d'abord (penser) → Claude Code ensuite (construire) → Alterner pour améliorer</div>
                  </div>
                  <div className="faq-item">
                    <div className="faq-q">Ça remplace un vrai développeur ?</div>
                    <div className="faq-a"><strong>Pour 90% des projets, oui.</strong> Sites, apps, MVPs, outils internes... Tu peux tout faire. Pour les projets très complexes (banque, santé...), un dev reste nécessaire.</div>
                  </div>
                  <div className="faq-item">
                    <div className="faq-q">Combien de temps pour maîtriser ?</div>
                    <div className="faq-a">
                      <strong>Très rapide :</strong><br/>
                      • 1 projet = Tu comprends le principe<br/>
                      • 3 projets = Tu es à l'aise<br/>
                      • 10 projets = Tu es un expert
                    </div>
                  </div>
                  <div className="faq-item">
                    <div className="faq-q">Et si je n'ai aucune connaissance en code ?</div>
                    <div className="faq-a"><strong>C'est justement le but !</strong> La Fusion te permet de créer sans coder. Claude Code écrit le code pour toi, tu n'as qu'à décrire ce que tu veux.</div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Telegram Widget */}
          <TelegramWidget />

          {/* Conclusion */}
          <div className="track-conclusion">
            <div className="conclusion-content">
              <h3>🎉 Tu maîtrises maintenant la Fusion !</h3>
              <p>
                Tu sais combiner ChatGPT et Claude Code pour créer n'importe quel projet digital.
                <br/><br/>
                <strong>Ta prochaine étape :</strong> Crée ton premier projet avec la Fusion dès maintenant !
              </p>
              <div className="conclusion-actions">
                <button className="btn-primary" onClick={() => navigate('/formation/chatgpt')}>Revoir ChatGPT</button>
                <button className="btn-secondary" onClick={() => navigate('/formation/claude')}>Revoir Claude Code</button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default FusionTrack;
